import React, { useState, useContext, useEffect } from 'react';
import { Grid, TextField, DialogActions, Button, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './styles.module.css';
import { AlertMessagesContext } from 'react-alert-messages';
import VariantService from 'services/VariantService';
import { useTranslation } from 'react-i18next';

export default function VariantEditDialog({ variant, handleClose, handleSuccess }) {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  const [isLoading, setLoading] = useState(false);
  const [variantData, setVariantData] = useState({ name: '' });
  const { postAlertMessage } = useContext(AlertMessagesContext);

  useEffect(() => {
    if (variant) {
      setVariantData({ name: variant.name || '' });
    }
  }, [variant]);

  const handleUpdateVariant = async () => {
    if (!variantData.name.trim()) return;
    setLoading(true);

    try {
      const updated = await VariantService.updateVariantDimension(variant.id, {
        name: variantData.name.trim(),
      });
      postAlertMessage({ type: 'success', text: tPopup('Variant Dimension updated successfully.') });
      handleSuccess(updated);
    } catch (error) {
      postAlertMessage({ type: 'error', text: error?.message || tPopup('Failed to update variant dimension.') });
      handleClose();
    }
    setLoading(false);
  };

  if (!variant) return null;

  return (
    <>
      <div className={styles.popUp}>
        <div className={styles.contentWrapper}>
          <div className={styles.headSec}>
            <h2 className={styles.editTitle}>{tCommon('Edit Variant')}</h2>
            <CloseIcon onClick={handleClose} className={styles.closeBtn} />
          </div>

          <div className={styles.inputSec}>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Variant Name')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  label={tCommon('Variant Name')}
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={variantData.name}
                  onChange={(e) => setVariantData({ name: e.target.value })}
                  disabled={isLoading}
                />
              </Grid>
            </Grid>
          </div>

          <div className={styles.footSec}>
            <DialogActions>
              <Button variant="contained" color="secondary" size="small" onClick={handleClose} disabled={isLoading}>
                {tCommon('Close')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ backgroundColor: '#00a65a' }}
                disabled={!variantData.name.trim() || isLoading}
                onClick={handleUpdateVariant}
              >
                {isLoading ? (
                  <>
                    <CircularProgress size={20} color="inherit" style={{ marginRight: '10px' }} />
                    {tCommon('Updating...')}
                  </>
                ) : (
                  tCommon('Update')
                )}
              </Button>
            </DialogActions>
          </div>
        </div>
      </div>
    </>
  );
}
